import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

// No ads on web.
@Composable
actual fun AdMobIntegration(modifier: Modifier, onLoadedChange: (Boolean) -> Unit) {
}
